import { gql } from '@apollo/client';

export default gql`
  query productLabNote(
    $partnerLocationId: ID!
    $isPlan: Boolean
    $isRetainer: Boolean
    $isEot: Boolean
  ) {
    productLabNote(
      partnerLocationId: $partnerLocationId
      isPlan: $isPlan
      isRetainer: $isRetainer
      isEot: $isEot
    ) {
      id
      name
    }
  }
`;
